import Pusher from "pusher-js";
import jwtDecode from "jwt-decode";
import PusherBatchAuthorizer from "./pusher-auth-batch";

import AppActions from "../../apps/data/app/AppActions";
import Cookies from "../cookies";
import {
    PUSHER_ACCESS_KEY,
    USER_CHANNEL_PREFIX,
    PUSHER_URL,
    FLAG_NEW_PUSHER_AUTH,
    PUSHER_URL_V2,
    PUSHER_SERVER_URL
} from "../constants";

const SOCKET_ERROR_BANNER_DELAY = 30000; // 30 sec
let socketErrorBannerTimeout;

let disconnectStartAt = null;
const MAX_DISCONNECTED_MS = 2 * 60 * 1000; // 2 minutes

function showSocketErrorBanner() {
    disconnectStartAt = Date.now();

    if (socketErrorBannerTimeout) {
        return;
    }

    socketErrorBannerTimeout = setTimeout(() => {
        AppActions.setDisplaySocketConnectionIssueBanner(true);
    }, SOCKET_ERROR_BANNER_DELAY);
}

const userToken = Cookies.get("userToken");
let userChannel;
let pusher;

if (userToken) {
    const pusherOpts = {
        cluster: "zeplin",
        encrypted: true,
        enabledTransports: ["ws", "wss"],
        authEndpoint: FLAG_NEW_PUSHER_AUTH ? PUSHER_URL_V2 : PUSHER_URL,
        auth: {
            headers: {
                "Zeplin-Token": userToken
            }
        },
        ...(PUSHER_SERVER_URL && PUSHER_SERVER_URL !== "undefined" ? { wsHost: PUSHER_SERVER_URL } : {})
    };
    if (FLAG_NEW_PUSHER_AUTH) {
        Object.assign(pusherOpts, {
            authorizer: PusherBatchAuthorizer,
            // Give page some time to load its content and then authorize
            // In the mean time, all of the auth requests are queued and send as a single request
            authDelay: 2000
        });
    }
    pusher = new Pusher(PUSHER_ACCESS_KEY, pusherOpts);

    pusher.connection.bind("failed", showSocketErrorBanner);
    pusher.connection.bind("unavailable", showSocketErrorBanner);
    pusher.connection.bind("disconnected", showSocketErrorBanner);

    pusher.connection.bind("connected", () => {
        Zeplin.headers.set("Zeplin-Socket-Id", pusher.connection.socket_id);

        clearTimeout(socketErrorBannerTimeout);
        socketErrorBannerTimeout = null;
        AppActions.setDisplaySocketConnectionIssueBanner(false);

        if (disconnectStartAt) {
            const timeDisconnected = Date.now() - disconnectStartAt;

            if (timeDisconnected > MAX_DISCONNECTED_MS) {
                window.location.reload();
            }

            disconnectStartAt = null;
        }
    });

    const { sub: userId } = jwtDecode(userToken);
    userChannel = pusher.subscribe(`${USER_CHANNEL_PREFIX}${userId}`);
}

export { userChannel };
export default pusher;
